<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [apibtoast, apigeneric],
  props: ["Id"],
  data() {
    return {
      FormData: {},
      pic: {}
    };
  },
  components: {
    Loader,
  },
  watch: {
    Id(){
        this.ActionsSingleGet({
        Service: "omalzeme",
        Id: this.Id.Malzemeid,
      }).then((res) => {
          this.pic = res.Data.Image
          });
    }
  },
  created() {

  },
  methods: {
    Get() {

    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="eye"
      size="md"
      title="Malzeme Görseli"
      title-class="font-18"
      hide-footer
    >
    <div class="row">
        <div class="col-md-12 text-center">
            <img v-if="pic != null" :src="$config.FILES_URL + 'sat/' + pic" alt="" style="height: 250px; width: 250px;"/>
            <h4 v-else class="text-center">Görsel Mevcut Değil</h4>
        </div>
    </div>

    </b-modal>
  </Loader>
</template>
